import { render, staticRenderFns } from "./OperatorsOptions.vue?vue&type=template&id=13084006&scoped=true"
import script from "./OperatorsOptions.vue?vue&type=script&lang=js"
export * from "./OperatorsOptions.vue?vue&type=script&lang=js"
import style0 from "./OperatorsOptions.vue?vue&type=style&index=0&id=13084006&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13084006",
  null
  
)

export default component.exports